import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import Label from "../Label";
import TextInput from "../TextInputs";
import globalStyle from "../../globalStyle";
import appcolors from "../../constants/Colors";
import GlobalButton from "../CustomButton";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogContent-root": {
    padding: "0 2rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0 8px",
    },
  },
  "& .MuiDialogActions-root": {
    padding: "25px 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "25px  8px",
    },
  },
}));
let paramsData = {};

const CategoryServiceBlockDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle
        sx={{ m: 0, p: 2, textAlign: "center", color: "primary.main" }}
        id="customized-dialog-title"
      >
        You want to block this Service
      </DialogTitle>
      <DialogContent sx={{ padding: { xs: "0px 0px !impor", md: "0px 20px" } }}>
        <Label labelText="Give us a reason" required />
        <TextInput
          styleProps={globalStyle.textField}
          placeholder={"10-100 words"}
          multiline
          rows={4}
        />
        <Typography variant="body2" my={1}>
          <span style={{ color: appcolors.primary }}>Note:</span> Confirmation
          email is send it to B2B@gmail.com
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"cancel"}
          handleClickBtn={handleClose}
        />
        <GlobalButton
          variant={"contained"}
          btnText={"Yes"}
          handleClickBtn={handleClose}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default CategoryServiceBlockDialog;
